/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { callbackTwilioGather } from '../fn/operations/callback-twilio-gather';
import { CallbackTwilioGather$Params } from '../fn/operations/callback-twilio-gather';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `callbackTwilioGather()` */
  static readonly CallbackTwilioGatherPath = '/custom/ticket/twilio/gather';

  /**
   * CallbackUrl called by Twilio for indicate a gather input from voiceCall.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `callbackTwilioGather()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackTwilioGather$Response(params?: CallbackTwilioGather$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return callbackTwilioGather(this.http, this.rootUrl, params, context);
  }

  /**
   * CallbackUrl called by Twilio for indicate a gather input from voiceCall.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `callbackTwilioGather$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackTwilioGather(params?: CallbackTwilioGather$Params, context?: HttpContext): Observable<void> {
    return this.callbackTwilioGather$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
